export interface TimerApi {
  setTimeout(callback: () => void, delayMs: number): number;
  clearTimeout(id: number): void;
}

export interface DiagnosticsGestureBinding {
  destroy(): void;
}

export function bindHoldToOpen(
  target: EventTarget,
  onOpen: () => void,
  timers: TimerApi,
  delayMs = 2000,
): DiagnosticsGestureBinding {
  let timerId: number | null = null;
  let destroyed = false;

  const cancel = (): void => {
    if (timerId === null) return;
    timers.clearTimeout(timerId);
    timerId = null;
  };
  const begin = (): void => {
    if (destroyed || timerId !== null) return;
    timerId = timers.setTimeout(() => {
      timerId = null;
      if (!destroyed) onOpen();
    }, delayMs);
  };

  target.addEventListener("pointerdown", begin);
  target.addEventListener("pointerup", cancel);
  target.addEventListener("pointercancel", cancel);
  target.addEventListener("pointerleave", cancel);

  return {
    destroy(): void {
      if (destroyed) return;
      destroyed = true;
      cancel();
      target.removeEventListener("pointerdown", begin);
      target.removeEventListener("pointerup", cancel);
      target.removeEventListener("pointercancel", cancel);
      target.removeEventListener("pointerleave", cancel);
    },
  };
}

export class TwoContactProbe {
  private readonly active = new Set<number>();
  private dwellStartMs: number | null = null;
  private passed = false;

  constructor(private readonly requiredMs = 750) {}

  press(pointerId: number, atMs: number): void {
    const hadTwo = this.active.size >= 2;
    this.active.add(pointerId);
    if (!this.passed && !hadTwo && this.active.size >= 2) {
      this.dwellStartMs = atMs;
    }
  }

  release(pointerId: number): void {
    this.active.delete(pointerId);
    if (!this.passed && this.active.size < 2) this.dwellStartMs = null;
  }

  update(nowMs: number): boolean {
    if (this.passed) return true;
    if (
      this.active.size >= 2 &&
      this.dwellStartMs !== null &&
      nowMs - this.dwellStartMs >= this.requiredMs
    ) {
      this.passed = true;
    }
    return this.passed;
  }
}
